import React from 'react';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';

import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Snackbar from '@material-ui/core/Snackbar';

import {SnackbarContentWrapper} from './index';

import * as snackbarActions from '../../../actions/snackbarActions';

import anchorOriginPositions from '../../../constants/anchorOriginPositions';

class Snackbars extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.handleClose = this.handleClose.bind(this);
    }

    getSnackbars(snackbars) {
        return snackbars.map(snackbar => {
            return (
                <ClickAwayListener
                    key={snackbar.id}
                    onClickAway={() => this.handleClose(snackbar)}
                >
                    <Snackbar
                        anchorOrigin={snackbar.anchorOrigin ? anchorOriginPositions[snackbar.anchorOrigin] : anchorOriginPositions.BOTTOM_LEFT}
                        autoHideDuration={5000}
                        open={true}
                    >
                        <SnackbarContentWrapper
                            message={snackbar.message}
                            messageId={snackbar.messageId}
                            onClose={() => this.handleClose(snackbar)}
                            variant={snackbar.variant}
                        />
                    </Snackbar>
                </ClickAwayListener>
            );
        });
    }

    handleClose(snackbar) {
        if (snackbar.onClose) {
            snackbar.onClose();
        }
        this.props.snackbarActions.removeSnackbar(snackbar.id);
    }

    render() {
        return (
            <div className="snackbars">
                {this.getSnackbars(this.props.snackbars)}
            </div>
        );
    }
}

Snackbar.propTypes = {
    snackbars: PropTypes.array,
    snackbarActions: PropTypes.objectOf(PropTypes.func)
};

function mapStateToProps(state) {
    return {
        snackbars: state.snackbars.items
    };
}

function mapDispatchToProps(dispatch) {
    return {
        snackbarActions: bindActionCreators(snackbarActions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Snackbars);


// WEBPACK FOOTER //
// ./src/components/common/snackbar/Snackbars.js